<template>
<section class="login-page">
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5">
        <div class="login-card shadow-lg">
          <div class="card-body p-4 p-sm-5">
            <div class="text-center mb-4">
              <img src="@/assets/trax.png" alt="Traxby" class="login-logo mb-3">
              <h3 class="mb-2">Sign in to TIW</h3>
              <p class="text-muted mb-0">Use your TIW administrator account.</p>
            </div>

            <div v-if="errorMessage" class="alert alert-danger" role="alert">
              {{ errorMessage }}
            </div>

            <form @submit.prevent="Login" novalidate>
              <div class="mb-3">
                <label class="form-label" for="typeEmailX">Email</label>
                <input
                  type="email"
                  id="typeEmailX"
                  class="form-control form-control-lg"
                  autocomplete="email"
                  v-model.trim="email"
                  @input="clearError"
                />
              </div>

              <div class="mb-4">
                <label class="form-label" for="typePasswordX">Password</label>
                <input
                  type="password"
                  id="typePasswordX"
                  class="form-control form-control-lg"
                  autocomplete="current-password"
                  v-model="password"
                  @input="clearError"
                />
              </div>

              <button class="btn btn-primary btn-lg w-100" type="submit" value="Login" :disabled="isLoading || !email || !password">
                <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                {{ isLoading ? 'Signing in...' : 'Login' }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import { ref } from 'vue'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import { evaluateTiwAdminAccess } from '@/services/adminDirectory'

export default {
  setup() {
    const email = ref("")
    const password = ref("")
    const errorMessage = ref("")
    const isLoading = ref(false)

    const clearError = () => {
      errorMessage.value = ""
    }

    const getLoginError = (err) => {
      if (err && err.code === 'auth/invalid-credential') {
        return 'The email or password is incorrect.'
      }
      if (err && err.code === 'auth/too-many-requests') {
        return 'Too many login attempts. Please try again later.'
      }
      return (err && err.message) || 'Unable to sign in. Please try again.'
    }

    const Login = async () => {
      if (!email.value || !password.value || isLoading.value) return

      errorMessage.value = ""
      isLoading.value = true

      try {
        const authClient = firebase.auth()
        const credentials = await authClient
          .signInWithEmailAndPassword(email.value, password.value)

        const accessDecision = await evaluateTiwAdminAccess(credentials?.user?.email)
        if (!accessDecision.allowed) {
          if (typeof authClient.signOut === 'function') {
            await authClient.signOut().catch(() => {})
          }
          errorMessage.value = accessDecision.message
        }
      } catch (err) {
        errorMessage.value = getLoginError(err)
      } finally {
        isLoading.value = false
      }
    }

    return {
      Login,
      email,
      password,
      errorMessage,
      isLoading,
      clearError
    }
  }
  
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #101418;
}

.login-card {
  background: #ffffff;
  border-radius: 8px;
}

.login-logo {
  max-height: 48px;
  max-width: 160px;
}
</style>
